<template>
  <div class="bigBox">
    <div class="typeTitle">{{tenantName}}</div>
    <div class="typeBox">
      <div class="typeChild" @click="personnel">
        <img src="@/assets/scanCode/pseson.png" style="width:150px;height:150px;"/>
        <div class="textStyle">人员登记</div>
      </div>
      <div class="typeChild" style="margin-top:50px;" @click="peopleAndCar">
        <img src="@/assets/scanCode/car.png" style="width:150px;height:150px;"/>
        <div class="textStyle">人车登记</div>
      </div>
      <!-- <div>{{url}}</div>
      <div>{{tenantCode}}</div> -->
    </div>
  </div>
</template>
<script>
export default {
  name: 'registerNoLogin',
  data () {
    return {
      url:'',
      tenantCode:'',
      tenantName:''
    }
  },
  created () {
    this.url = window.location.href;
    let obj = this.getQueryVariable(this.url)
    this.tenantCode = obj.tenantCode
    this.tenantName = obj.tenantName
    document.title = '登记类型';
    // console.log(this.url,'this.url')
    // console.log(this.tenantCode,'this.tenantCode')
    // console.log(this.tenantName,'this.tenantName')
  },
  methods: {
    getQueryVariable (variable) {
      let href = window.location.href//获取url
      href = decodeURI(href);//使用 decodeURI() 对一个编码后的 URI 进行解码：
      //或者使用decodeURIComponent(href)
      let query = href.substring(href.indexOf('?') + 1);//获取？后面的参数部分
      let param = query.split("&");//将参数部分-用&分割，转换成数组
      let obj = {}
      for (var i = 0; i < param.length; i++) {
          let per = param[i].split("=");//将数组中的每一项-用=分割，转换成数组
          obj[per[0]] = per[1]//以键值对的形式储存
      }
      return obj;
    },
    personnel(){
      this.$router.push({ name: 'personnelNoLogin',query: {tenantCode: this.tenantCode,tenantName: this.tenantName}})
    },
    peopleAndCar(){
      this.$router.push({ name: 'peopleAndCarNoLogin',query: {tenantCode: this.tenantCode,tenantName: this.tenantName}})
    }
  },
}
</script>
<style scoped lang='less'>
.bigBox{
  width: 100vm;
  height: 100vh;
  background-color: #fff;
  overflow: hidden;
}
.typeTitle{
  font-size: 23px;
  margin-top: 50px;
  text-align: center;
  font-weight: 700;
}
.typeBox{
  width: 65%;
  height: 400px;
  position: absolute;
  top:50%;
  left:50%;
  transform:translate(-50%,-50%);
}
.typeChild{
  display: flex;
  justify-content: space-around;
  .textStyle{
    line-height: 150px;
    font-weight: 700;
    font-size: 23px;
  }
}
</style>